export enum OperatorString {
  ENDS_WITH = 'string_ends_with',
  EQ = 'equal_to',
  GT = 'greater_than',
  GTE = 'greater_than_or_equal_to',
  IN = 'in',
  INCLUDES = 'string_includes',
  LT = 'less_than',
  LTE = 'less_than_or_equal_to',
  NEQ = 'not_equal_to',
  STARTS_WITH = 'string_starts_with',
}

export enum OperatorLabel {
  ENDS_WITH = 'ends with',
  EQ = 'is equal to',
  GT = 'is greater than',
  GTE = 'is greater than or equal to',
  INCLUDES = 'contains',
  LT = 'is less than',
  LTE = 'is less than or equal to',
  STARTS_WITH = 'starts with',
}

export const OperatorOperations = {
  [OperatorString.GT]: (a: number, b: number) => a > b,
  [OperatorString.GTE]: (a: number, b: number) => a >= b,
  [OperatorString.LT]: (a: number, b: number) => a < b,
  [OperatorString.LTE]: (a: number, b: number) => a <= b,
};

// Used in business rule GET response
export type Comparator =
  | OperatorString.ENDS_WITH
  | OperatorString.EQ
  | OperatorString.GT
  | OperatorString.GTE
  | OperatorString.IN
  | OperatorString.IN
  | OperatorString.INCLUDES
  | OperatorString.LT
  | OperatorString.LTE
  | OperatorString.NEQ
  | OperatorString.STARTS_WITH;

export const OperatorStringToLabelMap = {
  [OperatorString.ENDS_WITH]: OperatorLabel.ENDS_WITH,
  [OperatorString.EQ]: OperatorLabel.EQ,
  [OperatorString.GT]: OperatorLabel.GT,
  [OperatorString.GTE]: OperatorLabel.GTE,
  [OperatorString.INCLUDES]: OperatorLabel.INCLUDES,
  [OperatorString.LT]: OperatorLabel.LT,
  [OperatorString.LTE]: OperatorLabel.LTE,
  [OperatorString.STARTS_WITH]: OperatorLabel.STARTS_WITH,
};

export const OperatorOption = {
  [OperatorString.ENDS_WITH]: { label: OperatorLabel.ENDS_WITH, value: OperatorString.ENDS_WITH },
  [OperatorString.EQ]: { label: OperatorLabel.EQ, value: OperatorString.EQ },
  [OperatorString.GT]: { label: OperatorLabel.GT, value: OperatorString.GT },
  [OperatorString.GTE]: { label: OperatorLabel.GTE, value: OperatorString.GTE },
  [OperatorString.INCLUDES]: { label: OperatorLabel.INCLUDES, value: OperatorString.INCLUDES },
  [OperatorString.LT]: {
    label: OperatorLabel.LT,
    value: OperatorString.LT,
  },
  [OperatorString.LTE]: { label: OperatorLabel.LTE, value: OperatorString.LTE },
  [OperatorString.STARTS_WITH]: {
    label: OperatorLabel.STARTS_WITH,
    value: OperatorString.STARTS_WITH,
  },
};

export enum LogicalOperatorEnum {
  AND = 'AND',
  OR = 'OR',
}

export type LogicalOperator = LogicalOperatorEnum.AND | LogicalOperatorEnum.OR;
